import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import type { FETCH_TYPES, IFetcher, IFetchRequest, IFetchResponse } from '../interface/fetch';
import { bindFetch, injectFetch, unbindFetch } from '../interface/fetch';
import type { IProgressPromise } from '../interface/promise';
import { injectProgressPromise } from '../interface/promise';
import TYPES from '../util/types';
const loader = import('./fetch.decorator.retry');

const DEFAULT_TIMEOUT_MS = 30000; /* 30s */

async function _build(container: IContainer): Promise<IFetcher> {
    const promiser = injectProgressPromise(container);

    const module = await loader;

    const resolver = <T extends FETCH_TYPES>(
        requestPayload: IFetchRequest,
        timeout = DEFAULT_TIMEOUT_MS,
        retryCount = 0,
    ): IProgressPromise<IFetchResponse<T>> =>
        module.default<T>(promiser, requestPayload, timeout, retryCount);

    return Object.freeze(resolver);
}

export default buildBindable<IFetcher>({
    id: TYPES.IFetch,
    dependencies: [TYPES.IProgressPromiseGenerator],
    bind: bindFetch,
    remove: unbindFetch,
    inject: injectFetch,
    build: container => _build(container),
});
